const C = {
  name: "Sound",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.58579 3H13V21H9.58579L4.58579 16H0V8H4.58579L9.58579 3ZM10.4142 5L5.41421 10H2V14H5.41421L10.4142 19H11V5H10.4142Z" fill="currentColor"/>
<path d="M17.1229 9.87711C16.5615 9.31571 15.7963 9 15 9V7C16.3237 7 17.5985 7.52429 18.5371 8.46289C19.4757 9.4015 20 10.6763 20 12C20 13.3237 19.4757 14.5985 18.5371 15.5371C17.5985 16.4757 16.3237 17 15 17V15C15.7963 15 16.5615 14.6843 17.1229 14.1229C17.6843 13.5615 18 12.7963 18 12C18 11.2037 17.6843 10.4385 17.1229 9.87711Z" fill="currentColor"/>
<path d="M15 5C16.8563 5 18.6415 5.73571 19.9529 7.04711C21.2643 8.3585 22 10.1437 22 12C22 13.8563 21.2643 15.6415 19.9529 16.9529C18.6415 18.2643 16.8563 19 15 19V21C17.3837 21 19.6785 20.0557 21.3671 18.3671C23.0557 16.6785 24 14.3837 24 12C24 9.6163 23.0557 7.3215 21.3671 5.63289C19.6785 3.94429 17.3837 3 15 3V5Z" fill="currentColor"/>
</svg>
  `
};
export {
  C as Sound
};
